import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { body2, caption, colors, overline, spacing } from 'ui/theme';
import { AlignTypes } from 'ui/tableHeader';

const customSpacing = {
  p56: pxToRem(56),
  p100: pxToRem(100),
};

export const BaseCell = styled.div`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  overflow-y: visible;
  color: ${colors.textPrimary};
  padding: ${spacing.threeQuarter};
  margin: 0;
  vertical-align: middle;
`;

export const FlexCellWrapper = styled.div<{ align?: AlignTypes }>`
  align-items: ${(props) => (props?.align ? props?.align : 'flex-start')};
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
`;

export const StyledVariantTableCell = styled(BaseCell)`
  padding: ${spacing.base} 0 ${spacing.base} 0 !important;
`;

export const SecondaryContent = styled.div`
  ${caption};
  color: ${colors.textSecondary};
`;

export const PrimaryTextSecondaryColor = styled.div`
  color: ${colors.textSecondary};
`;

export const PrimaryText = styled.div`
  font-feature-settings: 'tnum' on, 'lnum' on;
`;

export const PrimaryContent = styled.div<{ color?: string }>`
  color: ${(props) => (props?.color ? props?.color : colors.textPrimary)};
`;

export const StyledLiftPrimaryText = styled(PrimaryContent)`
  min-width: ${customSpacing.p100};
  text-align: right;
`;

export const HoldoutWrapper = styled.div`
  align-items: center;
  display: flex;
  padding: ${spacing.plusHalf} ${spacing.base} ${spacing.plusHalf} ${spacing.double};
`;

export const HoldoutContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
  padding-left: ${spacing.base};
`;

export const HoldoutIcon = styled.div`
  ${overline}
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${customSpacing.p56};
  height: ${spacing.x3};
  background-color: ${colors.grey10};
  border: ${spacing.single} solid rgba(0, 0, 0, 0.05);
  border-radius: ${spacing.threeEights};
`;

export const HoldoutInnerWrapper = styled.div`
  display: flex;
  padding: ${spacing.base} ${spacing.base} ${spacing.base} 0;
`;

export const HoldoutHeader = styled.div`
  ${body2}
`;

export const HoldoutDetails = styled.div`
  ${caption}
  color: ${colors.textSecondary};
`;

export const TextNoWrap = styled.div`
  white-space: nowrap;
`;
